import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendComscoreBeacon } from '@/libs/comscore';

export const useComscorePageView = () => {
  const location = useLocation();

  useEffect(() => {
    sendComscoreBeacon();
  }, [location.pathname]);
};
